import React from 'react';
import { motion } from 'framer-motion';
import man from '../Assets/img/ryan_headshot.png';

const About = () => {
  return (
    <section id="About" className="section-wrap about-section">
      <div className="content-grid">
        <motion.div
          className="hero-copy"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <p className="eyebrow">Software Engineer</p>
          <p className="hero-body">
            My name is Ryan, a software engineer with over 10 years of experience, including my recent role as a
            software engineer at Riceland Foods. I&apos;m also a proud father of three. In my free time, I enjoy
            exploring new technologies, playing video games, and participating in sports. Primarily I spend my time
            with Oracle technologies, but I have experience with a variety of programming languages and frameworks. I
            love learning and working on projects I think are cool.
          </p>
          <div className="hero-actions">
            <a href="#Work" className="primary-btn">
              View Projects
            </a>
            <a href="#Contact" className="secondary-btn">
              Contact Me
            </a>
          </div>
        </motion.div>

        <motion.div
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.94 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.55, ease: 'easeOut' }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className="portrait-orb" />
          <img alt="Ryan Lee profile" className="profile-shot" src={man} />
          <div className="stat-card">
            <p className="stat-label">Experience</p>
            <p className="stat-value">10+ Years</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
